module.exports = __webpack_public_path__ + "static/img/publicite-en-ligne-small.3641611c.jpg";